import React, { useEffect, useState, useCallback, useMemo } from "react";
import { AppListing } from "../../components/appListing";
import { referralsApi } from "../../redux/service/referrals_service";
import { IoMdEye } from "react-icons/io";
import { toast } from "react-toastify";
import moment from "moment";
import MainPageDialog from "../../components/mainPageDialog";
import { getFileUrl } from "../care_plan/constant";

function Referrals() {
  const [referralsListingTrigger] =
    referralsApi.endpoints.getReferrals.useLazyQuery();
  const [referralsList, setReferralsList] = useState([]);
  const [referralsType, setReferralsType] = useState("outgoing");
  const [showReferralModal, setShowReferralModal] = useState({
    show: false,
    uuid: "",
  });
  const [loading, setLoading] = useState(false);

  const previewData = useCallback((item) => {
    setShowReferralModal({
      show: true,
      uuid: item?.referral_print_uuid,
    });
  }, []);

  const fetchReferrals = useCallback(
    async (type) => {
      setLoading(true);
      try {
        const response = await referralsListingTrigger({
          referral_type: type,
          shared_to_patient_portal: 1,
        });
        if (response?.data?.data) {
          setReferralsList(response.data.data);
        } else {
          setReferralsList([]);
        }
      } catch (error) {
        console.error("Error fetching referrals", error);
        toast.error("Error fetching referrals");
        setReferralsList([]);
      } finally {
        setLoading(false);
      }
    },
    [referralsListingTrigger]
  );

  useEffect(() => {
    fetchReferrals(referralsType);
  }, [fetchReferrals, referralsType]);

  const handleGetReferrals = useCallback(
    (type) => {
      if (type !== referralsType) {
        setReferralsType(type);
      }
    },
    [referralsType]
  );

  const columns = useMemo(
    () => [
      {
        title: "Referred To Date",
        key: "referred_to_date",
        getData: (item) =>
          moment(item.referred_to_date).format("MM/DD/YYYY hh:mm A"),
      },
      { title: "Reason", key: "reason" },
      { title: "Referral/Auth No.", key: "referral_no" },
      { title: "Referring Provider", key: "referring_by_name" },
      { title: "Referred To", key: "referring_to_name" },
      { title: "Status", key: "referral_status_title" },
      { title: "Last Updated By", key: "updated_by_name" },
      {
        title: "Preview",
        key: "preview",
        colClass: "col-md-1 text-center",
        getData: (item) => (
          <div className="flex w-full items-center justify-center px-2">
            <IoMdEye
              onClick={() => previewData(item)}
              className="cursor-pointer"
            />
          </div>
        ),
      },
    ],
    [previewData]
  );

  const footerList = [
    {
      title: "Close",
      type: "cancel",
      action: () => {
        setShowReferralModal({
          show: false,
          uuid: "",
        });
      },
    },
  ];

  return (
    <>
      {showReferralModal?.show && (
        <MainPageDialog
          title="Referral Report"
          modalSize="md"
          maxHeight={true}
          footerList={footerList}
          onCancelHandler={() =>
            setShowReferralModal({
              show: false,
              uuid: "",
            })
          }
        >
          <div
            dangerouslySetInnerHTML={{
              __html: `<iframe id="printDiv" width="100%" height="1100" scrolling="auto" frameborder="1" allow="autoplay" src=${getFileUrl(
                showReferralModal?.uuid
              )}></iframe>`,
            }}
          ></div>
        </MainPageDialog>
      )}
      <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
        <div className="flex gap-5 items-center">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Referrals
          </h3>
          <div className="flex gap-2">
            <button
              type="button"
              className={`relative inline-flex items-center rounded-sm ${
                referralsType === "outgoing"
                  ? "bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  : ""
              }`}
              onClick={() => handleGetReferrals("outgoing")}
            >
              Outgoing
            </button>
            {/* <button
              type="button"
              className={`relative inline-flex items-center rounded-sm ${
                referralsType === "incoming"
                  ? "bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  : ""
              }`}
              onClick={() => handleGetReferrals("incoming")}
            >
              Incoming
            </button> */}
          </div>
        </div>
        <div className="flex-shrink-0">
          <button
            type="button"
            onClick={() => fetchReferrals(referralsType)}
            className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Reload
          </button>
        </div>
      </div>
      <div className="flex-auto bg-white justify-start p-3 text-start">
        <AppListing loading={loading} listData={referralsList} cols={columns} />
      </div>
    </>
  );
}

export default React.memo(Referrals);
